import * as Yup from 'yup';
import { greaterThan } from 'utils/forms';

export const validationSchema = Yup.object().shape({
  name: Yup.string().required('global.forms.validations.required').nullable(),
  // Share is optional (FR-LPAY-14).
  share: Yup.number()
    .nullable()
    .transform((value, original) => (original === '' ? null : value))
    .max(100, greaterThan(100))
    .typeError('global.forms.validations.types.number'),
});
